/* Relaxbro theme JS */
(function () {
  /* mobile nav */
  function initNav() {
    var burger = document.querySelector('[data-burger]');
    var panel = document.querySelector('[data-mobilenav]');
    if (burger && panel) {
      burger.addEventListener('click', function () {
        panel.classList.toggle('open');
      });
    }
  }

  /* hero slideshow */
  function initHero() {
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('.rb-hero__slide');
      var dots = hero.querySelectorAll('.rb-hero__dots button');
      if (slides.length < 2) return;
      var i = 0, timer;
      function go(n) {
        slides[i].classList.remove('on');
        if (dots[i]) dots[i].classList.remove('on');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('on');
        if (dots[i]) dots[i].classList.add('on');
      }
      function auto() { timer = setInterval(function () { go(i + 1); }, 6000); }
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { clearInterval(timer); go(n); auto(); });
      });
      auto();
    });
  }

  /* scroll reveal */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  }

  /* product gallery thumbs */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gal) {
      var main = gal.querySelector('.main img');
      gal.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('on'); });
          btn.classList.add('on');
          if (main) { main.src = btn.getAttribute('data-full'); main.alt = btn.getAttribute('data-alt') || ''; }
        });
      });
    });
  }

  /* quantity steppers */
  function initQty() {
    document.querySelectorAll('.rb-qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        var v = parseInt(input.value, 10) || 1;
        v += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* tech scroll story */
  function initTech() {
    document.querySelectorAll('[data-tech]').forEach(function (root) {
var track = root.querySelector('.rb-tech__track');
var steps = root.querySelectorAll('.rb-tech__step');
var imgs = root.querySelectorAll('.rb-tech__vis img');
var bar = root.querySelector('.rb-tech__prog .bar i');
var now = root.querySelector('[data-tpnow]');
if (!track || steps.length === 0) return;
var sticky = root.querySelector('.rb-tech__sticky');
var textWrap = root.querySelector('.rb-tech__in > div:first-child');
var inner = null;
if (textWrap && textWrap.parentElement) {
inner = document.createElement('div');
inner.className = 'rb-tech__stepsInner';
while (textWrap.firstChild) { inner.appendChild(textWrap.firstChild); }
textWrap.appendChild(inner);
}
var ticking = false;
function isDesktop() {
return !!(sticky && window.getComputedStyle(sticky).position === 'sticky');
}
function syncHeight() {
if (textWrap && sticky && isDesktop()) {
textWrap.style.height = sticky.clientHeight + 'px';
textWrap.style.overflow = 'hidden';
textWrap.style.position = 'relative';
} else if (textWrap) {
textWrap.style.height = '';
textWrap.style.overflow = '';
textWrap.style.position = '';
if (inner) inner.style.transform = '';
}
}
function update() {
ticking = false;
var r = track.getBoundingClientRect();
var total = r.height - window.innerHeight;
if (total <= 0) return;
var p = Math.min(1, Math.max(0, -r.top / total));
var idx = Math.min(steps.length - 1, Math.floor(p * steps.length));
steps.forEach(function (s, i) { s.classList.toggle('on', i === idx); });
imgs.forEach(function (im, i) { im.classList.toggle('on', i === idx); });
if (bar) bar.style.width = (p * 100) + '%';
if (now) now.textContent = ('0' + (idx + 1)).slice(-2);
if (inner && textWrap && isDesktop()) {
var activeStep = steps[idx];
var winH = textWrap.clientHeight;
var target = activeStep.offsetTop + activeStep.offsetHeight / 2 - winH / 2;
var maxTarget = Math.max(0, inner.scrollHeight - winH);
target = Math.max(0, Math.min(target, maxTarget));
inner.style.transition = 'transform .35s ease';
inner.style.transform = 'translateY(' + (-target) + 'px)';
}
}
function onScroll() {
if (!ticking) { ticking = true; requestAnimationFrame(update); }
}
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', function () { syncHeight(); onScroll(); });
syncHeight();
update();
    });
  }

  /* collection sort */
  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav(); initHero(); initReveal(); initGallery(); initQty(); initSort(); initTech();
  });
})();
